/**
 * @namespace toolkit.models
 */
 
 /**
 * @class toolkit.models.ErrorBlockModel
 * @classdesc The error model for error block component.
 */
export class ErrorBlockModel {

    /**
     * shows the error message.
     */
    public showError: boolean;

    /**
     * the error message.
     */
    public errorMessage: string;

    /**
     * the error title.
     */
    public errorTitle: string;

}


// WEBPACK FOOTER //
// ./src/models/errorBlock.ts